/**
 * Created by Victor Rojo on 27/8/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import {Widget} from "./Widget";

@Injectable()
export class WidgetService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(sectionId:string): Promise<any>{
    let url = this.basePath + "section/" + sectionId + "/widget";
    return this.http.get(url)
      .toPromise()
      .then( res => res as Widget[])
      .catch( error => this.errorHandler(error) );
  }

  getStatusError(): Promise<any>{
    let url = this.basePath + "widget/status-error";
    return this.http.get(url)
      .toPromise()
      .then( res => res as Widget[])
      .catch( error => this.errorHandler(error) );
  }

  setMaintenanceMode(widgetId:string, active:boolean): Promise<any>{
    let url = this.basePath + "widget/" + widgetId + "/maintenance";
    return this.http.put(url, active ? 1 : 0, {responseType: 'text'})
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }

  getWidgetSeries(widgetId:string, start:number, end:number, interval: string, groupFunction: string){
    let url = this.basePath + "widget/" + widgetId + "/series";
    let params = new HttpParams();
    params = params.append('startDate', start.toString())
              .append('endDate', end.toString());
    if ( interval && groupFunction ) {
      params = params.append("interval", interval)
        .append("function", groupFunction)
    }
    return this.http.get(url, { params: params })
      .toPromise()
      .catch( error => this.errorHandler(error) );

  }

}
